import { useState } from 'react'
import { Box, Typography, Grid, Divider } from '@mui/material'

import { Button } from '@/@core/components/mui/Button'
import { FilterButton } from '../common'
import { TableLimit } from '@/@core/components/mui/TableLimit'
import UserStatusSelection from '../selection/UserStatusSelection'
import { useRouteQuery, useTranslator } from '@/hooks'
import { SearchInput } from '../common/SearchInput'
import InputDateField from '../common/input/InputDateField'
import { CreateEmployeeDrawer } from '../user'

interface EmployerDetailTableFilterProps {
  onSearch?: (value: string) => void
  onAddEmployee?: () => void
  refetch: () => void
  businessNumber?: string
}

export const EmployerDetailTableFilter = ({ refetch, businessNumber }: EmployerDetailTableFilterProps) => {
  const { __ } = useTranslator()
  const { updateQuery, searchQuery } = useRouteQuery()
  const [filter, setFilter] = useState(true)
  const [isOpenCreateInternalUserDrawer, setIsOpenCreateInternalUserDrawer] = useState(false)
  const { id } = useParams()

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '20px',
        gap: 4,
        flexDirection: 'column'
      }}
    >
      {filter && (
        <>
          <Box className='mb-3'>
            <Typography variant='h6' className='mb-3'>
              {__('Filters')}
            </Typography>
            <Grid container spacing={2}>
              <Grid size={6}>
                <InputDateField
                  value={searchQuery.get('birth_date') || ''}
                  placeholder={__('Select Date')}
                  onChange={birth_date => {
                    updateQuery({ birth_date })
                  }}
                />
              </Grid>
              <Grid size={6}>
                <UserStatusSelection
                  value={searchQuery.get('status') || ''}
                  onSelect={status => {
                    updateQuery({ status })
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />
        </>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TableLimit />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <SearchInput
            placeholder={__('Search User')}
            onSearch={value => {
              updateQuery({ keywords: value })
            }}
          />

          <FilterButton filter={filter} onFilter={() => setFilter(!filter)} />

          <Button
            variant='contained'
            onClick={() => setIsOpenCreateInternalUserDrawer(true)}
            startIcon={<i className='tabler-plus' />}
            sx={{ height: 38 }}
          >
            <span className='text-[15px] font-medium'>{__('Add Employee')}</span>
          </Button>
        </Box>
      </Box>

      <CreateEmployeeDrawer
        open={isOpenCreateInternalUserDrawer}
        setOpen={setIsOpenCreateInternalUserDrawer}
        companyId={Number(id)}
        businessNumber={businessNumber}
        onSuccess={() => {
          refetch()
        }}
      />
    </Box>
  )
}
